import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PosthogService } from 'src/app/services/posthog.service';
import { ProfileService } from 'src/app/services/profile.service';
import { DataLayerService } from 'src/app/services/data-layer.service';

@Component({
  selector: 'app-commercial-communications',
  templateUrl: './commercial-communications.component.html',
  styleUrls: ['./commercial-communications.component.scss'],
})
export class CommercialCommunicationsComponent implements OnInit {

  @Output() public closeModalEvent = new EventEmitter<any>();
  @Input() profile: any;
  @Input() initialStep: string = 'allCommunications';

  loading = false;
  step = 'allCommunications';
  phoneData: { prefix: string; phone: string } | null = null;
  phoneError = false;

  textAll = '';
  textConfirmed = '';
  btnList: any;
  btnConfirmedList: any;
  variant: any;

  title = '';
  subtitle = '';
  imageconfirmed = 13;

  constructor(
    public chdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private profileService: ProfileService,
    private posthogService: PosthogService,
    private dataLayerService: DataLayerService
  ) { }

  ngOnInit() {
    this.step = this.initialStep;
    this.posthogService.getExperimentVariant('modal-recuperar-cc').then(flagObj => {
      this.variant = flagObj.value;
      this.title = this.variant === 'test' ? this.translate.instant('NOTIFICATIONS.TEST_TITLE') : this.translate.instant('NOTIFICATIONS.CONTROL_TITLE');
      this.subtitle = this.variant === 'test' ? this.translate.instant('NOTIFICATIONS.TEST_SUBTITLE') : this.translate.instant('NOTIFICATIONS.CONTROL_SUBTITLE');
      this.chdRef.detectChanges();
    });

    this.btnList = [
      {
        type: 'primaryDark',
        index: 1,
        title: this.translate.instant('register.btn.accept'),
      },
      {
        type: 'secondaryDark',
        index: 2,
        title: this.translate.instant('BIOMETRIC.CANCEL'),
      }
    ];
    this.btnConfirmedList = [
      {
        type: 'primaryDark',
        index: 1,
        title: this.translate.instant('NOTIFICATIONS.UNDERSTAND'),
      }
    ];
    this.textAll = this.translate.instant('NOTIFICATIONS.ASK_FOR_COMMUNICATIONS');
    this.textConfirmed = this.translate.instant('NOTIFICATIONS.CONFIRM_COMMUNICATIONS');
    this.sendEvent('accept_communications_modal_displayed');
    this.chdRef.detectChanges();
  }

  allCommunications(val: number) {
    if (val === 1) {
      this.subscribeToCommunications();
    } else {
      this.closeModal();
    }
    this.chdRef.detectChanges();
  }

  subscribeToCommunications() {
    this.loading = true;
    const model = {
      communications: true,
      email: this.profile.username,
    };
    this.profileService.subscribeFullCommunications(this.profile.username).subscribe(() => {
      this.profileService.setAcceptCommunications(model).subscribe(() => {
        this.step = 'confirmed';
        this.loading = false;
        this.sendEvent('user_accept_communications');
        this.chdRef.detectChanges();
      }, () => {
        this.communicationsIssue();
        this.chdRef.detectChanges();
      });
      this.chdRef.detectChanges();
    }, error => {
      this.communicationsIssue();
      this.chdRef.detectChanges();
    });
    this.chdRef.detectChanges();
  }

  confirmedAction(val: number) {
    if (val !== 1) {
      window.open(`https://info.fundeen.com/gestiona-tus-comunicaciones?email=${this.profile.username}`);
    }
    this.closeModal();
  }

  saveWhatsapp() {
    this.loading = true;
    const prefix = this.phoneData?.prefix || '+34';
    const dialCode = prefix.replace(/^\+/, '');
    const rawPhone = (this.phoneData?.phone || this.profile?.mobile || '').replace(/[\s\+\-\(\)]/g, '');
    const localPhone = rawPhone.startsWith(dialCode) ? rawPhone.slice(dialCode.length) : rawPhone;
    const mobile = localPhone ? prefix + localPhone : undefined;
    this.profileService.subscribeWhatsapp(mobile).subscribe(() => {
      this.loading = false;
      this.step = 'confirmed';
      this.textConfirmed = this.translate.instant('NOTIFICATIONS.WHATSAPP_CONFIRMED');
      this.btnConfirmedList = [{ type: 'primaryDark', index: 1, title: this.translate.instant('NOTIFICATIONS.UNDERSTAND') }];
      this.sendEvent('accept_whatsapp_ok');
      this.chdRef.detectChanges();
    }, () => {
      this.loading = false;
      this.closeModal();
      this.chdRef.detectChanges();
    });
  }

  closeModal() {
    this.closeModalEvent.emit();
    this.chdRef.detectChanges();
  }

  sendEvent(evt: string) {
    const params = {
      username: this.profile.username,
      profileType: this.profile.profileType,
    }
    this.posthogService.pushEventParams(evt, params);
    this.dataLayerService.pushCustomEventGTM(evt);
    this.chdRef.detectChanges();
  }

  communicationsIssue() {
    this.sendEvent('accept_communications_error');
    this.step = 'confirmed';
    this.imageconfirmed = 1;
    this.textConfirmed = this.translate.instant('NOTIFICATIONS.HUBSPOT_ISSUE');
    this.btnConfirmedList = [
      {
        type: 'primaryDark',
        index: 2,
        title: this.translate.instant('LOGIN.CONTINUE'),
      }
    ];
    this.loading = false;
    this.chdRef.detectChanges();
  }
}
